// extracted by mini-css-extract-plugin
export default {"blockwrapper":"qM","header":"rM","name":"sM","columns":"tM","imagewrapper":"uM","addinfo":"vM","description":"wM","price":"xM","old":"yM","new":"zM","desc_d":"AM","infoblock":"BM","desc_m":"CM"};
    if(module.hot) {
      // 1713361652282
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  